(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/components/draw-selector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/components/draw-selector.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _svs$sport$drawSelect = svs.sport.drawSelectorAssets,
  DrawSelectorItem = _svs$sport$drawSelect.DrawSelectorItem,
  DrawSelectorList = _svs$sport$drawSelect.DrawSelectorList;
class DrawSelector extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      showList: false
    });
    _defineProperty(this, "handleToggleList", () => {
      if (this.props.draws.length > 1) {
        this.setState(state => ({
          showList: !state.showList
        }));
      }
    });
    _defineProperty(this, "handleChangeDrawHandler", drawNumber => {
      this.setState({
        showList: false
      });
      this.props.selectDraw(drawNumber);
    });
  }
  renderDropDownArrow() {
    if (this.props.draws.length < 2) {
      return null;
    }
    const iconClassName = "icon-default js-caret".concat(this.state.showList ? ' icon-menu-up' : ' icon-menu-down');
    return React.createElement("div", {
      className: "right-side"
    }, React.createElement("i", {
      className: iconClassName
    }));
  }
  render() {
    const _this$props = this.props,
      draws = _this$props.draws,
      drawNumber = _this$props.drawNumber,
      onToggle = _this$props.onToggle,
      branding = _this$props.branding;
    const currentDraw = this.props.draws.filter(draw => draw.drawNumber === drawNumber)[0];
    const headerClassName = "draw-selector-header".concat(draws.length > 1 ? ' pointer' : '', " ").concat(branding);
    return React.createElement("div", {
      id: "draw-selector"
    }, React.createElement("div", {
      className: headerClassName,
      onClick: this.handleToggleList
    }, React.createElement("div", {
      className: "left-side"
    }, React.createElement(DrawSelectorItem, {
      draw: currentDraw,
      partOfList: false
    })), this.renderDropDownArrow()), React.createElement(DrawSelectorList, {
      draws: draws,
      onChangeDrawHandler: this.handleChangeDrawHandler,
      onToggle: onToggle,
      selectedDraw: drawNumber,
      showList: this.state.showList
    }));
  }
}
setGlobal('svs.sport.DrawSelector', DrawSelector);

 })(window);